import { render, staticRenderFns } from "./Department-dialog.vue?vue&type=template&id=6715fb20&"
import script from "./Department-dialog.vue?vue&type=script&lang=js&"
export * from "./Department-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports